// removed by extract-text-webpack-plugin
module.exports = {"primary":"#aa4121","secondary":"#ccc","gray":"#636363"};